module.exports = __webpack_public_path__ + "img/network_r.f70abd89.png";